module.exports = __webpack_public_path__ + "img/newcomer.f0215a67.png";